import { render, staticRenderFns } from "./ReportCardBarChart.vue?vue&type=template&id=337fdd50"
import script from "./ReportCardBarChart.vue?vue&type=script&lang=ts"
export * from "./ReportCardBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports